import React from "react";
import styles from "../../styles/SuccessStories/ServiceBanner.module.css";
import { useNavigate } from "react-router-dom";

const ServiceBanner = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div className={styles.serviceBannerContainer}>
      <div className={styles.serviceBannerInnerContainer}>
        <div className={styles.serviceBannerContent}>
          <div className={styles.serviceBannerTitle}>Real Startups, Real Success</div>
          <div className={styles.serviceBannerDescription}>
            Discover how startups transformed their vision into reality with
            LovenCoders.
          </div>
          <div className={styles.serviceBannerBtn} onClick={handleGetStarted}>Start Your Journey</div>
        </div>
        <div>
          <img src="/success-banner.svg" alt="success-icon" className={styles.img} />
        </div>
      </div>
    </div>
  );
};

export default ServiceBanner;
